import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { ElectionContact } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-cerfa-contact-verification',
  templateUrl: 'cerfa-contact-verification.component.html',
  styleUrls: ['./cerfa-contact-verification.component.less', '../../../shared/common.less'],
})

export class CerfaContactVerificationComponent implements OnInit {
  @Input() contact: ElectionContact;
  @Input() isValidated: boolean = false;
  @Output() contactChange = new EventEmitter<ElectionContact>();
  @Output() validated = new EventEmitter<boolean>();
  @Output() editRequested = new EventEmitter<void>();
  isExpanded: boolean = true;
  needPap: boolean = undefined;

  constructor() {}
  
  onContactChange() {
    this.contactChange.emit(this.contact);
  }

  onlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }

  trackByIndex(index: number): number {
    return index;
  }

  onEdit() {
    this.editRequested.emit();
  }

  onValidate() {
    this.isExpanded = false;
    this.isValidated = true;
    this.validated.emit(true);
  }

  
  ngOnInit(): void {
  }
}
